export default "__VITE_ASSET__LQkVag8w__"